<template>
  <div class="shop_recharge-record boxbgcolor">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div>
    <div class="right content-right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <!-- <div class="form-group">
						<label for="">订单编号:</label>
						<input  v-model="search.orderNum" class="form-control"  type="text" placeholder="" size="12"/>	
          </div>-->
          <div class="form-group">
            <label for>商户:</label>
            <el-select v-model="search.shopsId" @focus="getShop()" clearable placeholder="请选择">
              <el-option
                v-for="item in allShopsByParkingId"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>付款方式:</label>
            <el-select v-model="search.payType" clearable placeholder="请选择">
              <el-option
                v-for="item in allPayTypeData"
                :key="item.value"
                :label="item.labelDefault"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for="bdate">缴费时间:</label>
            <el-date-picker
              v-model="search.chargeTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
          <!-- <div class="form-group">
						<label for="">订单编号:</label>
						<input  v-model="search.plateNumber" class="form-control"  type="text" placeholder="" size="12"/>	
					</div>
                    <div class="form-group">
						<label for="">车主姓名:</label>
						<input  v-model="search.orderNumber" class="form-control"  type="text" placeholder="" size="12"/>
					</div>
					 <div class="form-group">
						<label for="bdate">开始时间:</label>
						<el-date-picker clearable
							value-format="yyyy-MM-dd HH:mm:ss"
							v-model="search.beginDate"
							type="date"
							>
						</el-date-picker>
					</div>
					<div class="form-group">
						<label for="bdate">结束时间:</label>
						<el-date-picker clearable
							value-format="yyyy-MM-dd HH::mm:ss"
							v-model="search.endDate"
							type="date"
							r>
						</el-date-picker> 
          </div>-->

          <div class="form-group others">
            <span class="search_btn">
              <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
            </span>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
            
            <!-- <span class="refresh_btn"><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          :data="tableListData.rows"
          border
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column  show-overflow-tooltip label="订单编号" prop="orderNum"></el-table-column>
          <el-table-column  show-overflow-tooltip label="商家名称" prop="shopsId">
            <template slot-scope="scope">{{scope.row.shopsId?JSON.parse(scope.row.shopsId).name:''}}</template>
          </el-table-column>
          <el-table-column  show-overflow-tooltip label="充值前余额" prop="ordRecharge"></el-table-column>
          <el-table-column  show-overflow-tooltip label="充值金额" prop="realMoney"></el-table-column>
          <el-table-column  show-overflow-tooltip label="充值后余额" prop="nowRecharge"></el-table-column>
          <el-table-column  show-overflow-tooltip label="充值时间" prop="chargeDate"></el-table-column>
          <el-table-column  show-overflow-tooltip label="充值方式" prop="payType"></el-table-column>
        </el-table>
      </div>
    </div>

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  shopRechargeRecordAPI,
  getPosList,
  requestAllPayType
} from "@/api/url";

import Page from "../../commons/page.vue";

import AreaTree from "../../commons/parking/commons/areaTree.vue";

import Refresh from "../../commons/parking/commons/refresh.vue";

export default {
  data() {
    return {
      treeData: {
        parkingId: ""
      },
      styleObj: {
        "text-align": "center"
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB"
      },
      allShopsByParkingId: [],
      allPayTypeData: [],
      allFbType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        chargeTime: [],
        payType: "",
        shopsId: ""
        // orderNum:'',
      },
      tableListData: {
        rows: []
      },
      defaultProps: {
        children: "children",
        label: "label"
      },

      formLabelWidth: "100px",

      dialogFormVisiblePhoto: false,
      allImgUrl: [],
      imgUrl: ""
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
       if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场"
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function(node, data) {
      this.allShopsByParkingId = [];
      this.search.chargeTime = [];
      this.search.shopsId = "";
      this.search.payType = "";
      if (node.type == "parking") {
        this.treeData.parkingId = node.id;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
        this.getAllShopsByParkingId();
      } else {
        this.treeData.parkingId = node.id;
        this.tableListData.rows = [];
        // this.$message({
        // 	type:'warning',
        // 	message:'请选择车场'
        // })
      }
    },
    tableList: function(curPage) {
      var _this = this;
      this.$get(shopRechargeRecordAPI(), {
        parkingId: this.treeData.parkingId,
        beginTime: this.search.chargeTime ? this.search.chargeTime[0] : "",
        endTime: this.search.chargeTime ? this.search.chargeTime[1] : "",
        shopsId: this.search.shopsId,
        payType: this.search.payType,
        limit: this.search.pageSize,
        page: curPage
      }).then(data => {
        if (data.status != 200) return;
        //翻页
        var rows = data.data.rows;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total
        };
        _this.getPage(pageObj);
        _this.tableListData.rows = data.data.rows;
      });
    },
    getAllShopsByParkingId: function() {
      this.$get(getPosList(), {
        parkingId: this.treeData.parkingId,
        limit: 0,
        page: 0
      }).then(data => {
        this.allShopsByParkingId = data.data.rows;
      });
    },
    getShop() {
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择车场"
        });
        return;
      }
    },
    getAllPayType() {
      this.$get(requestAllPayType()).then(data => {
        this.allPayTypeData = data.data.rows;
      });
    },
    searchList: function() {
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择车场"
        });
        return;
      }
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      // this.search.pageNumber="1";
      // this.search.fbMsg="";
    }
  },
  computed: {
    ...mapState({
      curIndex: state => state.page.curIndex,
      rowsCount: state => state.page.rowsCount
    })
  },
  components: {
    Page,
    AreaTree,
    Refresh
  },

  created: function() {
    this.getAllPayType();
    // this.tableList(this.search.pageNumber)
  }
};
</script>

<style scoped>
.boxbgcolor {
  /*margin-top:20px;*/
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  /* height:130px;
		line-height:45px; */
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
.demo-table-expand {
  font-size: 0;
}
.detail {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.detail ul {
  width: 50%;
}
.detail ul li {
  padding: 10px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail ul li span {
  display: inline-block;
  width: 50%;
}
.detail ul li span:first-child {
  text-align: right;
  color: #aaa;
  font-weight: bold;
  width: 100px;
}
.detail ul li span:last-child {
  text-align: left;
  padding: 0 0 0 20px;
}
</style>
<style>
.shop_recharge-record .el-select {
  width: 100px;
}
</style>